export default __webpack_public_path__ + "static/media/Apercu-Regular-Pro.095d564b.woff";